import { Component } from '@angular/core';

@Component({
    selector: 'app-page-404',
    template: `
    <div class='center'>
      <img src="http://assets.pokemon.com/assets/cms2/img/pokedex/full/035.png"/>
      <h1>Sorry, cette page n'existe pas !</h1>
      <a routerLink="/pokemon/all" class="waves-effect waves-teal btn-flat">
        Retourner à l' accueil
      </a>
    </div>
  `
})
export class PageNotFoundComponent { }
